import * as React from 'react';

import { ModalMFAToken } from './ModalMFAToken';
import { ModalMFAVerifyPhone } from './ModalMFAVerifyPhone';

export type PagesType = 'phone' | 'code' | 'finish';

type Props = {
  currentPage: PagesType;
  isPhoneNumberValid: boolean;
  isMobileNumber: boolean;
  isVerifyPhoneLoading: boolean;
  isOpen: boolean;
  phoneNumber: string;
  onVerifyPhone: () => void;
  onClose: () => void;
  onPhoneNumberChange: (phone: string) => void;
  onMfaTokenValidated: () => void;
  verifyPhoneStepTitle?: string;
  tokenStepTitle?: string;
  showAppCallout?: boolean;
};

export const ModalMFA = ({
  currentPage,
  isPhoneNumberValid,
  isMobileNumber,
  isVerifyPhoneLoading,
  isOpen,
  phoneNumber,
  onVerifyPhone,
  onClose,
  onPhoneNumberChange,
  onMfaTokenValidated,
  verifyPhoneStepTitle,
  tokenStepTitle,
  showAppCallout = true,
}: Props) => (
  <>
    <ModalMFAVerifyPhone
      onClose={onClose}
      onVerifyPhone={onVerifyPhone}
      onPhoneNumberChange={onPhoneNumberChange}
      phoneNumber={phoneNumber}
      isPhoneNumberValid={isPhoneNumberValid}
      isMobileNumber={isMobileNumber}
      isLoading={isVerifyPhoneLoading}
      isOpen={isOpen && currentPage === 'phone'}
      title={verifyPhoneStepTitle}
      showAppCallout={showAppCallout}
    />
    <ModalMFAToken
      flow="standard"
      onMfaTokenValidated={onMfaTokenValidated}
      onClose={onClose}
      isOpen={isOpen && currentPage === 'code'}
      title={tokenStepTitle}
    />
  </>
);
